import { render } from "./Stats.vue?vue&type=template&id=ead72b56&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=ts"
export * from "./Stats.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-ead72b56"

export default script